import Vue from 'vue'
import moment from 'moment'

var currencyGlobalOptions = {
    globalOptions: {
        "distraction-free": "hideCurrencySymbol",
        currency: {
            prefix: "₺ "
        },
        locale: "tr-TR"
    }
};

import VueCurrencyInput, { setValue } from 'vue-currency-input'
import { parseCurrency } from 'vue-currency-input'

Vue.use(VueCurrencyInput, currencyGlobalOptions);

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    let arr = value.split(" ")
    let capitalized_array = []
    arr.forEach((word) => {
        let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
        capitalized_array.push(capitalized)
    })
    return capitalized_array.join(" ");
})

Vue.filter('title', function (value, replacer = "_") {
    if (!value) return ''
    value = value.toString()

    let arr = value.split(replacer)
    let capitalized_array = []
    arr.forEach((word) => {
        let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
        capitalized_array.push(capitalized)
    })
    return capitalized_array.join(" ");
})

Vue.filter('truncate', function (value, limit) {
    return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
    return value + tail;
})

Vue.filter('time', function (value, is24HrFormat = false) {
    if (value) {
        const date = new Date(Date.parse(value));
        let hours = date.getHours();
        const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
        if (!is24HrFormat) {
            const time = hours > 12 ? 'AM' : 'PM';
            hours = hours % 12 || 12;
            return hours + ':' + min + ' ' + time
        }
        return hours + ':' + min
    }
})

Vue.filter('date', function (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
})

Vue.filter('date_tr', function (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
})

Vue.filter('date_sql', function (value) {
    return moment(String(value)).format('YYYY/MM/DD')
})

Vue.filter('month', function (val, showYear = true) {
    val = String(val)

    const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
    if (!showYear) {
        return regx.exec(val)[1];
    } else {
        return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
    }

})

Vue.filter('csv', function (value) {
    return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
    return value.replace(/<\/?[^>]+(>|$)/g, "")
})

Vue.filter('k_formatter', function (num) {
    return num > 999 ? (num / 1000).toFixed(1) + 'k' : num
})

Vue.filter('v_currency', function (value) {
    return parseCurrency(value, currencyGlobalOptions.globalOptions);
}) 